import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useRef } from 'react';
import InputField from '../../../../../../../components/inputField/InputField';
import InputTextLengthCounter from '../../../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import SimpleTable from '../../../../../../../core/components/simpleTables/SimpleTable';
import BaseForm from '../../../../../../../core/page/components/baseForm/BaseForm';
import { arrayToDateString } from '../../../../../../../core/utils/DateMixins';
import apuracaoMetaService from '../../../../../../../service/ApuracaoMetaService';
import CollapseMeta from '../../../apuracaoResultado/components/collapseMeta/CollapseMeta';
import styles from './CollapseApuracao.module.scss';

const inputs = [
    {
        name: 'descAvaliacao',
        label: 'Avaliação do Resultado',
        form: { use: true, validate: { required: true, max: 3500 } },
    },
];

function CollapseApuracao({ meta, loadData }) {
    const formRef = useRef(null);
    const tableRef = useRef(null);

    const podeEditar =
        (meta?.apuracaoMeta?.avaliacaoApuracaoResultado?.situacaoAvaliacaoApuracao
            ?.codgSituacaoAvaliacao ?? 'PENDENTE') === 'PENDENTE';

    const Inputs = ({ formik, formController }) => {
        return (
            <form className={`p-col-12 p-grid p-fluid ${styles.form}`}>
                <InputField
                    id="descAvaliacao"
                    formik={formik}
                    cols="12"
                    formController={formController}
                >
                    <InputTextLengthCounter maxLen="3500">
                        <InputTextarea
                            rows={4}
                            readOnly={!podeEditar}
                            value={formik.values.descAvaliacao}
                            onChange={formik.handleChange}
                        />
                    </InputTextLengthCounter>
                </InputField>
            </form>
        );
    };

    const Table = () => {
        const dados = Array.isArray(meta?.apuracaoMeta?.avaliacaoApuracaoResultado?.dataAtualizacao)
            ? [
                  {
                      avaliacaoApuracaoResultado: {
                          dataAtualizacao: arrayToDateString(
                              meta?.apuracaoMeta?.avaliacaoApuracaoResultado?.dataAtualizacao
                          ),
                          situacaoAvaliacaoApuracao: {
                              descSituacaoAvaliacao:
                                  meta?.apuracaoMeta?.avaliacaoApuracaoResultado
                                      ?.situacaoAvaliacaoApuracao?.descSituacaoAvaliacao,
                          },
                          contaAcessoAtualizacao: {
                              nome:
                                  meta?.apuracaoMeta?.avaliacaoApuracaoResultado
                                      ?.contaAcessoAtualizacao?.nome ??
                                  meta?.apuracaoMeta?.avaliacaoApuracaoResultado
                                      ?.contaAcessoCadastro?.nome,
                          },
                      },
                  },
              ]
            : [];

        return (
            <SimpleTable
                className={styles.table}
                data={dados}
                ref={tableRef}
                col="6"
                paginator={false}
            >
                <Column
                    field="avaliacaoApuracaoResultado.situacaoAvaliacaoApuracao.descSituacaoAvaliacao"
                    header="Situação de Avaliação"
                />
                <Column field="avaliacaoApuracaoResultado.dataAtualizacao" header="Data" />
                <Column
                    field="avaliacaoApuracaoResultado.contaAcessoAtualizacao.nome"
                    header="Usuário"
                />
            </SimpleTable>
        );
    };
    return (
        <CollapseMeta disableActions {...meta}>
            <Fieldset className={styles.fieldset} legend="Avaliação">
                <BaseForm
                    ref={formRef}
                    buscarOnLoad={false}
                    onSubmit={({ registro }) =>
                        apuracaoMetaService.finalizarAvaliacao(meta?.apuracaoMeta?.id, registro)
                    }
                    actionOnSave={({ success }) => {
                        if (success && loadData) {
                            loadData();
                        }
                    }}
                    prepareInitialValues={async (dados) => ({
                        ...dados,
                        descAvaliacao:
                            meta?.apuracaoMeta?.avaliacaoApuracaoResultado?.descAvaliacao,
                    })}
                    initialValues={inputs}
                >
                    <Inputs />
                </BaseForm>
                <div className={`p-col-12 p-grid p-fluid ${styles.form}`}>
                    <Table />

                    <div className="p-col-6 ">
                        {podeEditar && (
                            <div className="buttonsRight">
                                <Button
                                    type="button"
                                    label="Salvar"
                                    onClick={() => {
                                        formRef.current.formik.setFieldValue('finalizacao', false);
                                        formRef.current.formController.addCountClick();
                                        formRef.current.formik.submitForm();
                                    }}
                                />
                                <Button
                                    type="button"
                                    label="Finalizar Avaliação"
                                    onClick={() => {
                                        formRef.current.formik.setFieldValue('finalizacao', true);
                                        formRef.current.formController.addCountClick();
                                        formRef.current.formik.submitForm();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </Fieldset>
        </CollapseMeta>
    );
}

export default CollapseApuracao;
